<ion-app (click)="handleTap()">
  @if (initialized()) {
    <ion-router-outlet></ion-router-outlet>
  }
  <yt-splash [show]="showSplash()"></yt-splash>
  @if (processingOverlay(); as overlay) {
    <yt-processing-overlay [title]="overlay.title" [description]="overlay.description"></yt-processing-overlay>
  }
  <yt-in-app-notification></yt-in-app-notification>
  <yt-web-push-banner></yt-web-push-banner>
  <yt-admin-overlay></yt-admin-overlay>
</ion-app>
